import React from "react";

// Styles
import styles from "./button.module.css";

// Types
interface ButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
  className?: string;
  type?: "primary" | "secondary" | "icon" | "default";
  variant?: "default" | "outline";
  icon?: React.ReactNode;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ children, onClick, className, type = "default", variant = "default", icon, ...props }) => {
  let buttonClass = `${styles.button} p-2 gap-2`;

  switch (type) {
    case "primary":
      buttonClass += ` ${styles.primary}`;
      break;
    case "secondary":
      buttonClass += ` ${styles.secondary}`;
      break;
    case "icon":
      buttonClass += ` ${styles.icon}`;
      break;
    case "default":
    default:
      break;
  }


  return (
    <button className={`${buttonClass} ${className}`} onClick={onClick} {...props}>
      {icon && <span className='w-6 h-6'>{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
